<svg
	style="fill: currentColor"
	height="8"
	viewBox="0 0 10 10"
	width="8"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M0.293063 6.50003C0.683528 6.8905 1.3166 6.8905 1.70706 6.50003L5.00006 3.20703L8.29306 6.50003C8.68353 6.8905 9.3166 6.8905 9.70706 6.50003C10.0975 6.10957 10.0975 5.4765 9.70706 5.08603L5.70706 1.08603C5.31656 0.69565 4.68356 0.69565 4.29306 1.08603L0.293062 5.08603C-0.0974035 5.4765 -0.0974026 6.10957 0.293063 6.50003Z"
		transform="rotate(180 5 5)"
	/>
</svg>
